import * as z from "zod/v4";

export const updateDiscountCodeSelfServe: {
  name: "updateDiscountCodeSelfServe";
  input: z.ZodObject<{
    orderIdOrOrderNoOrConfirmationNo: z.ZodString;
    customerEmail: z.ZodString;
    discountCode: z.ZodString;
  }>;
  output: z.ZodObject<{
    success: z.ZodBoolean;
    orderNumber: z.ZodString;
    error: z.ZodOptional<z.ZodString>;
    discountCode: z.ZodOptional<z.ZodString>;
  }>;
} = {
  name: "updateDiscountCodeSelfServe" as const,
  input: z.object({
    orderIdOrOrderNoOrConfirmationNo: z
      .string()
      .describe("The order number, ID, or confirmation number"),
    customerEmail: z
      .string()
      .describe("Customer's email address for verification"),
    discountCode: z
      .string()
      .describe("The discount code to apply to the order"),
  }),
  output: z.object({
    success: z.boolean(),
    orderNumber: z.string(),
    error: z.string().optional(),
    discountCode: z.string().optional(),
  }),
};
